export var createListFromSchema = function createListFromSchema(schema) {
  var arr = [];

  for (var key in schema) {
    arr.push({
      path: key,
      type: schema[key]
    });
  }

  return arr;
};